import AxiosAgent from "./AxiosAgent";
import * as Utils from "../utils/Utils";

const API_MAIN_ROOT = process.env.REACT_APP_BACKEND_ENDPOINT as string;

interface UserInfo {
    username: string;
    password?: string;
}

interface TokenRefreshRequest {
    refreshToken: string;
}

interface ForgetPasswordDTO {
    currentPassword: string;
    newPassword: string;
}

export const createRefreshToken = (userInfo: UserInfo) => {
    return AxiosAgent.requests.post(`${API_MAIN_ROOT}/auth/create-refresh-token`, userInfo);
};

export const logoutUser = () => {
    var logout = {
        "refreshToken": Utils.getRefreshToken()
    }
    return AxiosAgent.requests.postNoToken(`${API_MAIN_ROOT}/logout`, logout);
};

export const getAccessTokenByRefreshToken = (tokenRefreshRequest: TokenRefreshRequest) => {
    return AxiosAgent.requests.post(`${API_MAIN_ROOT}/auth/get-access-token-by-refresh-token`, tokenRefreshRequest);
};

export const getRefreshTokenByUserId = (userId: string) => {
    return AxiosAgent.requests.post(`${API_MAIN_ROOT}/auth/get-refresh-token-by-userId`, {userId});
};

export const changePassword = (forgetPasswordDTO: ForgetPasswordDTO) => {
    return AxiosAgent.requests.put("/auth/change-password", forgetPasswordDTO);
};
